import CheckinCheckoutCell from './checkin_checkout_cell';

export default CheckinCheckoutCell;
